import { ButtonProps } from '@mui/material';
import { useAwaiting } from 'shared/hooks';

import { LoadingButton } from '../loading-button';

export type AwaitableButtonProps = {
  isLoading?: boolean;
  isDisabled?: boolean;
  action: () => Promise<void>;
} & Omit<ButtonProps, 'onClick' | 'action'>;

export const AwaitableButton = ({ action, isDisabled, isLoading, children, ...props }: AwaitableButtonProps) => {
  const { await: load, isAwaiting } = useAwaiting(action);

  const handleClick = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    await load();
  };

  return (
    <LoadingButton
      onClick={handleClick}
      isLoading={isLoading || isAwaiting}
      disabled={isDisabled || isLoading}
      {...props}
    >
      {children}
    </LoadingButton>
  );
};
